export const specialProducersMinPriceConfig = {
  ve_60d387d0320b346f89698771: 4,
  ve_60d0c97250e77d5ccb588fd7: 4,
};
